import type { Input } from '@builder.io/sdk';

const tableMarqueFields = [
  {
    name: 'content',
    type: 'object',
    subFields: [
      {
        name: 'heading',
        type: 'string',
      },
      {
        name: 'superScript',
        type: 'string',
      },
      {
        name: 'callToAction',
        type: 'object',
        subFields: [
          {
            name: 'label',
            type: 'string',
          },
          {
            name: 'url',
            type: 'url',
          },
        ],
      },
    ],
  },
  {
    name: 'table',
    type: 'object',
    subFields: [
      {
        name: 'headings',
        type: 'list',
        subFields: [
          {
            name: 'heading',
            type: 'string',
          },
        ],
      },
      {
        name: 'reports',
        type: 'list',
        subFields: [
          {
            name: 'title',
            type: 'string',
          },
          {
            name: 'subtitle',
            type: 'string',
          },
          {
            name: 'profits',
            type: 'string',
            helperText: 'Please define profits separated by (,)',
          },
        ],
      },
    ],
  },
  {
    name: 'footerNote',
    type: 'richText',
  },
] as const satisfies DeepReadonly<Input[]>;

const tableMarqueConfig = {
  name: 'Table Marque',
  inputs: tableMarqueFields,
};

export type TableMarqueProps = GenerateBuilder<typeof tableMarqueFields>;

export default tableMarqueConfig;
